import { createStyles, makeStyles } from "../Utilities/ThemeHelper";
import { amber, green } from "@mui/material/colors";
const snackBarStyles = theme => ({
  variantSuccess: {
    backgroundColor: green[800],
    color: theme.palette.getContrastText(green[800])
  },
  variantError: {
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.getContrastText(theme.palette.error.dark)
  },
  variantInfo: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.getContrastText(theme.palette.primary.dark)
  },
  variantWarning: {
    backgroundColor: amber[600],
    color: theme.palette.getContrastText(amber[600])
  },
  root: {},
  fullWidth: {
    maxWidth: "100vw"
  },
  containerRoot: {
    // Fix issues with Material UI v4
    // TODO: Remove upon upgrade to MUI v5
    // https://github.com/iamhosseindhv/notistack/issues/394
    pointerEvents: "all",
    "& > div": {
      paddingTop: theme.spacing(1)
    }
  }
});

// The component itself uses the hook-based approach
export const useStyles = makeStyles(snackBarStyles);

// We need to provide styles to the SnackbarProvider in ProductThemeProvider which has to be done using withStyles
export const styles = createStyles(theme => {
  const renderedStyles = snackBarStyles(theme);
  delete renderedStyles.fullWidth;
  return renderedStyles;
});